module.exports = __webpack_public_path__ + "dist/index.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=dist/index.html!./src/index.html
// module id = 36
// module chunks = 0